/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function BinaryDocumentIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "binary-document", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M10.5 4.5H18.5V20.5H6.5V8.5L10.5 4.5Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M10.5 4.5V8.5H6.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M10.1 11.5V10.9H8.9V11.5H10.1ZM8.9 16.5V17.1H10.1V16.5H8.9ZM8.9 11.5V16.5H10.1V11.5H8.9Z", fill: "currentColor" }),
        React.createElement("path", { d: "M12.5 16.5V11.5H15.5V16.5H12.5Z", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(BinaryDocumentIcon);
export default ForwardRef;
//# sourceMappingURL=binaryDocumentIcon.js.map